module.exports = "<button class=\"btn btn-outline-black\" type=\"submit\">\r\n{{label}}</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/button/button.component.html
// module id = 1039
// module chunks = 22